window.webAdBaseUrl = document.currentScript.dataset.baseUrl;
window.webAdAbsoluteBaseUrlMitSpracheUndVerlag = document.currentScript.dataset.absoluteBaseUrlMitSpracheUndVerlag;
